import {useState} from 'react';
import {evolutionService} from 'services';

export function useFetchPosts() {
  const [fetching, setFetching] = useState(false);
  const [posts, setPosts] = useState([]);

  const fetch = async (options = {page: 0}) => {
    const {page} = options;
    setFetching(true);

    const posts = await evolutionService.getPosts({page});

    setFetching(false);
    setPosts(posts);
    return posts;
  };

  return {
    fetching,
    fetch,
    posts,
  };
}
